export enum UserManagementMode {
    create = 'create',
    edit = 'edit',
    profile = 'profile'
}


// WEBPACK FOOTER //
// ./src/types/user-management-mode.ts